function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { anim } from 'modapp-utils';
import RootElem from './RootElem';
import { translate, onLocaleUpdate, offLocaleUpdate } from './utils/l10n';
/**
 * A html component
 */

var Html =
/*#__PURE__*/
function (_RootElem) {
  _inherits(Html, _RootElem);

  /**
   * Creates an instance of Html
   * @param {string|LocaleString} html HTML string
   * @param {object} [opt] Optional parameters.
   * @param {string} [opt.tagName] Tag name (eg. 'span') for the element. Defaults to 'div'.
   * @param {string} [opt.className] Class name
   * @param {object} [opt.attributes] Key/value attributes object
   * @param {object} [opt.events] Key/value events object, where the key is the event name, and value is the callback.
   */
  function Html(html, opt) {
    var _this;

    _classCallCheck(this, Html);

    opt = Object.assign({
      tagName: 'div'
    }, opt);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Html).call(this, opt.tagName, opt));
    _this.html = html || "";
    _this.animId = null;
    _this.rendered = null; // Bind callbacks

    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Sets the html
   * @param {string} html HTML string
   * @returns {this}
   */


  _createClass(Html, [{
    key: "setHtml",
    value: function setHtml(html) {
      html = html || "";
      this.html = html;

      this._handleChange();

      return this;
    }
  }, {
    key: "setHtml",
    value: function setHtml(html) {
      html = html || "";

      if (this.html !== html) {
        var tmp = this.html;
        this.html = html;

        if (_get(_getPrototypeOf(Html.prototype), "getElement", this).call(this)) {
          offLocaleUpdate(tmp);

          this._handleChange();

          onLocaleUpdate(this.html);
        }
      }

      return this;
    }
  }, {
    key: "render",
    value: function render(el) {
      var nodeEl = _get(_getPrototypeOf(Html.prototype), "render", this).call(this, el);

      this.rendered = translate(this.html);
      nodeEl.innerHTML = this.rendered;
      onLocaleUpdate(this.html, this._handleChange);
      return nodeEl;
    }
  }, {
    key: "unrender",
    value: function unrender() {
      offLocaleUpdate(this.html, this._handleChange);
      anim.stop(this.animId);

      _get(_getPrototypeOf(Html.prototype), "unrender", this).call(this);

      this.rendered = null;
    }
  }, {
    key: "_handleChange",
    value: function _handleChange() {
      var _this2 = this;

      var el = _get(_getPrototypeOf(Html.prototype), "getElement", this).call(this);

      if (!el) {
        return;
      }

      anim.stop(this.animId);
      var next = translate(this.html);

      if (this.rendered === next) {
        this.animId = anim.fade(el, 1);
        return;
      }

      this.animId = anim.fade(el, 0, {
        callback: function callback() {
          var el = _get(_getPrototypeOf(Html.prototype), "getElement", _this2).call(_this2);

          if (!el) {
            return;
          }

          _this2.rendered = next;
          el.innerHTML = next;
          _this2.animId = anim.fade(el, 1);
        }
      });
    }
  }]);

  return Html;
}(RootElem);

export default Html;